import { combineReducers } from 'redux';

import forgotUiReducer from './forgotUiReducer';

export default combineReducers({
  ui: forgotUiReducer,
});
